import { render, staticRenderFns } from "./CalendarPage.vue?vue&type=template&id=39f297c5"
import script from "./CalendarPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports